import React from 'react'
import styled, { css } from 'styled-components'
import { Link, useHistory } from 'react-router-dom'
import { useCookies } from 'react-cookie'

import constants from 'utils/constants'

import kakaoIcon from 'images/icon/kakao_icon-42x38.png'
import appleIcon from 'images/apple.png'
import waterIcon from 'images/icon/background_water_icon-129x129.png'
import dumbbellIcon from 'images/icon/background_dumbbell_icon-139-107.png'
import saladIcon from 'images/icon/background_salad_icon-204x203.png'
import alarmIcon from 'images/icon/backgorund_alarm_icon-222x304.png'
import { sendWebViewMsg } from 'utils/bridge'

export default function SocialLogin({
  redirectPath,
  onPressAppleLogin,
  onPressKakaoLogin,
  onPressAppStore,
  showIOSSignup,
  showAppStore,
  isOnboarding = false,
}) {
  const [cookies, setCookie, removeCookie] = useCookies()
  const history = useHistory()

  const normalLoginRedirectPath = redirectPath ? `?redirect_path=${redirectPath}` : ''

  return (
    <SocialLoginBlock>
      {!showAppStore && isOnboarding ? (
        <OnboardingSocialLoginTop>
          <LeadLoginTitle>
            로그인을 하면
            <br />
            인증기록이 저장돼요.
          </LeadLoginTitle>
          <LeadLoginDescription>받을 수 있는 포인트를 놓치지 마세요✨</LeadLoginDescription>
        </OnboardingSocialLoginTop>
      ) : (
        <SocialLoginTop>
          <LogoArea>
            <LogoImg src={`${constants.imagePath}/common/logo/motiners_logo-364x76.png`} />
          </LogoArea>
          <DescriptionBlock>
            <DescriptionMain>
              건강기록 하고
              <br />
              매일 포인트 쌓자!
            </DescriptionMain>
            <DescriptionSub>함께 시작해 볼까요?</DescriptionSub>
          </DescriptionBlock>
          <AlarmIconBlock></AlarmIconBlock>
          <SaladIconBlock></SaladIconBlock>
          <WaterIconBlock></WaterIconBlock>
          <DumbbellIconBlock></DumbbellIconBlock>
        </SocialLoginTop>
      )}
      <SocialLoginBottom>
        {showAppStore ? (
          <AppStoreBtnBlock>
            <AppStoreBtn onClick={onPressAppStore}>앱 다운로드</AppStoreBtn>
          </AppStoreBtnBlock>
        ) : (
          <>
            <SocialLoginBtnBlock>
              <KakaoLoginBtn onClick={onPressKakaoLogin}>
                <KakaoIconBlock>
                  <SocialIcon src={kakaoIcon} />
                </KakaoIconBlock>
                5초만에 카카오로 시작하기
              </KakaoLoginBtn>
              {showIOSSignup === true ? (
                <AppleLoginBtn onClick={onPressAppleLogin}>
                  <AppleIconBlock>
                    <SocialIcon src={appleIcon} />
                  </AppleIconBlock>
                  Apple로 시작하기
                </AppleLoginBtn>
              ) : null}
            </SocialLoginBtnBlock>
            <FooterOptionsBlock>
              <LookAroundBtn
                onClick={(e) => {
                  e.preventDefault()
                  setCookie('is_onboarding_completed', 'true', {
                    path: '/',
                    maxAge: 60 * 60 * 24 * 365,
                  })
                  removeCookie('onboarding_habit', { path: '/' })
                  removeCookie('onboarding_description', { path: '/' })
                  removeCookie('onboarding_original_image_name', { path: '/' })
                  removeCookie('onboarding_original_image_path', { path: '/' })
                  removeCookie('onboarding_merged_image_name', { path: '/' })
                  removeCookie('onboarding_merged_image_path', { path: '/' })
                  sendWebViewMsg({ action: 'REQ_COOKIE_FLUSH' })
                  history.push('/')
                }}
              >
                둘러보기
              </LookAroundBtn>

              <DefaultLoginBtn
                onClick={() => {
                  if (isOnboarding) {
                    history.push(`/login${normalLoginRedirectPath}`, { isOnboarding })
                  } else {
                    history.push(`/login${normalLoginRedirectPath}`)
                  }
                }}
              >
                일반 로그인
              </DefaultLoginBtn>

              {/* <DefaultLoginBtn
                onClick={() => {
                  if (isOnboarding) {
                    history.push(`/signup${normalLoginRedirectPath}`, { isOnboarding })
                  } else {
                    history.push(`/login${normalLoginRedirectPath}`)
                  }
                }}
              >
                {isOnboarding ? '일반 회원가입' : '일반 로그인'}
              </DefaultLoginBtn> */}
            </FooterOptionsBlock>
            <PolicyAgreementTxt>
              가입을 진행할 경우, 서비스 약관 및 개인정보 처리방침에 동의한 것으로 간주합니다.
            </PolicyAgreementTxt>
          </>
        )}
      </SocialLoginBottom>
    </SocialLoginBlock>
  )
}

const SocialLoginBlock = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  height: 100%;
`

const SocialLoginTop = styled.div`
  margin-top: calc(100vw * (140 / 375));
`

const LogoArea = styled.div`
  width: calc(100vw * (134 / 375));
  margin: 0 auto;
`

const LogoImg = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
`

const DescriptionBlock = styled.div`
  margin-top: calc(100vw * (10 / 375));
  text-align: center;
`

const DescriptionMain = styled.p`
  font-weight: 700;
  font-size: calc(100vw * (24 / 375));
  line-height: calc(100vw * (35 / 375));
  color: #121212;
`

const DescriptionSub = styled.p`
  margin-top: calc(100vw * (10 / 375));
  font-weight: 500;
  font-size: calc(100vw * (14 / 375));
  line-height: calc(100vw * (20 / 375));
  color: #7f7f7f;
`

const SocialLoginBottom = styled.div`
  width: 100%;
  padding-bottom: calc(100vw * (6 / 375));
  z-index: 10;
`

const SocialLoginBtnBlock = styled.div`
  width: 100%;
  padding: 0 calc(100vw * (22 / 375));
`

const AppStoreBtnBlock = styled.div`
  width: 100%;
  padding: 0 calc(100vw * (22 / 375));
  margin-bottom: calc(100vw * (80 / 375));
`

const socialBtnStyle = css`
  width: 100%;
  font-size: calc(100vw * (16 / 375));
  font-weight: 500;
  font-family: 'Noto Sans', sans-serif;
  border-radius: calc(100vw * (6 / 375));
  padding: calc(100vw * (14 / 375)) 0;
  display: flex;
  align-items: center;
  justify-content: center;
`

const AppStoreBtn = styled.button`
  ${socialBtnStyle};
  background: #ffcf19;
  font-weight: 700;
  font-size: calc(100vw * (18 / 375));
  padding: calc(100vw * (20 / 375));
`

const KakaoLoginBtn = styled.button`
  ${socialBtnStyle};
  background: #fae100;
`

const AppleLoginBtn = styled.button`
  ${socialBtnStyle};
  background: #121212;
  color: #fff;
  margin-top: calc(100vw * (10 / 375));
`

const FooterOptionsBlock = styled.div`
  display: flex;
  justify-content: center;
  align-itens: center;
  width: 100%;
  margin-top: calc(100vw * (20 / 375));
`

const KakaoIconBlock = styled.div`
  display: inline-block;
  width: calc(100vw * (21 / 375));
  height: calc(100vw * (18 / 375));
  margin-right: calc(100vw * (8 / 375));
`

const AppleIconBlock = styled.div`
  display: inline-block;
  width: calc(100vw * (18 / 375));
  height: calc(100vw * (19 / 375));
  margin-right: calc(100vw * (8 / 375));
`

const SocialIcon = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
`

const linkStyle = css`
  font-size: calc(100vw * (12 / 375));
  color: #7f7f7f;
  text-decoration: underline;
  font-family: 'Noto Sans', sans-serif;
`

const LookAroundBtn = styled(Link)`
  ${linkStyle}
  border-right: 1px solid #989898;
  padding-right: calc(100vw * (12 / 375));
`

const DefaultLoginBtn = styled(Link)`
  ${linkStyle}
  padding-right: calc(100vw * (12 / 375));
  padding-left: calc(100vw * (12 / 375));
  & + & {
    border-left: 1px solid #989898;
    padding-right: 0;
  }
`

const PolicyAgreementTxt = styled.p`
  font-size: calc(100vw * (9 / 375));
  color: #7f7f7f;
  text-align: center;
  margin-top: calc(100vw * (25 / 375));
`

const AlarmIconBlock = styled.div`
  position: absolute;
  top: calc(100vw * (29 / 375));
  left: calc(100vw * (0 / 375));
  width: calc(100vw * (127.6 / 375));
  height: calc(100vw * (127.6 / 375));
  background: url(${alarmIcon});
  background-size: contain;
  background-repeat: no-repeat;
`

const SaladIconBlock = styled.div`
  position: absolute;
  top: calc(100vw * (308 / 375));
  left: calc(100vw * (25 / 375));
  width: calc(100vw * (84.71 / 375));
  height: calc(100vw * (84.71 / 375));
  background: url(${saladIcon});
  background-size: contain;
  background-repeat: no-repeat;
`

const WaterIconBlock = styled.div`
  position: absolute;
  top: calc(100vw * (105 / 375));
  left: calc(100vw * (302.34 / 375));
  width: calc(100vw * (60.18 / 375));
  height: calc(100vw * (60.18 / 375));
  background: url(${waterIcon});
  background-size: contain;
  background-repeat: no-repeat;
`

const DumbbellIconBlock = styled.div`
  position: absolute;
  top: calc(100vw * (410 / 375));
  left: calc(100vw * (233 / 375));
  width: calc(100vw * (60.76 / 375));
  height: calc(100vw * (35.28 / 375));
  background: url(${dumbbellIcon});
  background-size: contain;
  background-repeat: no-repeat;
`

const OnboardingSocialLoginTop = styled.div`
  width: 100%;
  margin-top: calc(100vw * (77 / 375));
  padding: 0 calc(100vw * (22 / 375));
`

const LeadLoginTitle = styled.div`
  font-weight: 700;
  font-size: calc(100vw * (23 / 375));
  line-height: calc(100vw * (36 / 375));
`

const LeadLoginDescription = styled.div`
  margin-top: calc(100vw * (8 / 375));
  font-weight: 500;
  font-size: calc(100vw * (16 / 375));
  line-height: calc(100vw * (24 / 375));
  color: #707070;
`
